import { IMsalContext } from "@azure/msal-react";
import { InteractionRequiredAuthError, InteractionStatus } from '@azure/msal-browser';
import { loginRequest } from "../AuthConfig";
import { jwtDecode } from "jwt-decode";
import { setRoles, setUserFirstname, setUserLastname } from "./Global";
import logger from './LoggingService';

/**
 * Authentication service for handling authentication requests 
 *
 * @export
 * @class AuthenticationService
 */
export class AuthenticationService {

    private context: IMsalContext;

    constructor(ctx: IMsalContext) {
        this.context = ctx;
    }

    
    /**
     * Get access token from the authentication context 
     *
     * @return {*}  {Promise<string>}
     * @memberof AuthenticationService
     */
    public getAccessToken(): Promise<string> {
        return new Promise(async (resolve, reject) => {
            const { instance, accounts } = this.context;
            const account = accounts[0]
            const scopes = loginRequest.scopes
            let response;
            try {
                response = await instance.acquireTokenSilent({
                    account: account!,
                    scopes: scopes
                });

                if (response.accessToken) {
                    var token: any = jwtDecode(response.accessToken);
                    setRoles(token.roles)
                    setUserFirstname(token.given_name ?? 'Profile');
                    setUserLastname(token.family_name ?? '');
                    resolve(response.accessToken);
                } else {
                    reject(Error('Failed to acquire an access token'));
                }
            } catch (error) {
                if (error instanceof InteractionRequiredAuthError) {
                    instance.acquireTokenRedirect({
                        scopes: scopes
                    });
                }
                else {
                    reject(error)
                }
            }
        });
    }

    
    /**
     * Login popup for authentication
     *
     * @memberof AuthenticationService
     */
    public loginPopup() {
        const { instance } = this.context;
        logger.debug('Initiating popup login', {
            interactionStatus: InteractionStatus,
            scopes: loginRequest.scopes
        }, {
            component: 'AuthenticationService',
            method: 'loginPopup'
        });
        
        const request = {
            scopes: loginRequest.scopes
        };
        instance.loginPopup(request).catch((error) => {
            logger.error('Authentication popup login failed', error as Error, {
                scopes: loginRequest.scopes,
                requestType: 'popup'
            }, {
                component: 'AuthenticationService',
                method: 'loginPopup'
            });
        });
    }

    
    /**
     * Login redirect for authentication
     *
     * @memberof AuthenticationService
     */
    public loginRedirect() {
        const { instance } = this.context;
        logger.debug('Initiating redirect login', {
            interactionStatus: InteractionStatus,
            scopes: loginRequest.scopes
        }, {
            component: 'AuthenticationService',
            method: 'loginRedirect'
        });
        
        const request = {
            scopes: loginRequest.scopes
        };
        instance.loginRedirect(request).catch((error) => {
            logger.error('Authentication redirect login failed', error as Error, {
                scopes: loginRequest.scopes,
                requestType: 'redirect'
            }, {
                component: 'AuthenticationService',
                method: 'loginRedirect'
            });
        });
    }


}